import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"mx-auto peeps--font"},[_c(VCardTitle,{staticClass:"display-1 peeps--text card-title"},[_vm._t("baseTitle",[_vm._v(" Hooray!"),_vm._t("title")])],2),_vm._t("image",[_c(VImg,{staticClass:"mx-auto",attrs:{"max-width":"200","src":require("@/assets/img/PeepsHooray.svg")}})]),_c(VCardText,[_vm._t("default")],2),_c(VCardActions,[_vm._t("action")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }